/**
 * Firebase Analytics — lightweight wrapper.
 * All keys here are publishable (Firebase web config is public by design).
 */
import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAnalytics, logEvent, type Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCFsb423CH7kFqedswTkdVDKh_Q29jHLgM",
  authDomain: "hydrolife-d7ead.firebaseapp.com",
  projectId: "hydrolife-d7ead",
  storageBucket: "hydrolife-d7ead.firebasestorage.app",
  messagingSenderId: "199562351790",
  appId: "1:199562351790:web:80d3549632595f452c493f",
  measurementId: "G-HFT8ZLB45H",
};

let analytics: Analytics | null = null;

export function initFirebase() {
  try {
    const app: FirebaseApp = initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn("Firebase init failed:", e);
  }
}

export function trackEvent(eventName: string, params: Record<string, unknown> = {}) {
  if (!analytics) return;
  try {
    logEvent(analytics, eventName, params);
  } catch {
    // silently fail
  }
}

export const AnalyticsEvents = {
  CUP_ADDED: () => trackEvent("cup_added"),
  GOAL_COMPLETED: () => trackEvent("daily_goal_completed"),
  TAB_VIEWED: (tab: string) => trackEvent("tab_viewed", { tab_name: tab }),
  FOOD_SEARCHED: (query: string) => trackEvent("food_searched", { query }),
  QUIZ_ANSWERED: (correct: boolean) => trackEvent("quiz_answered", { correct }),
  NOTIFICATION_ENABLED: () => trackEvent("notification_permission_granted"),
  PREMIUM_VIEWED: () => trackEvent("premium_page_viewed"),
};
